/**
 * Ціни: на вузьких екранах пакети йдуть у Swiper — рекомендований по центру, по
 * краях видно сусідні. На десктопі слайдер знищується й лишається сітка з CSS.
 *
 * ⚠ Поріг залежить від кількості пакетів і мусить збігатися зі style.scss:
 * чотири картки (.cols-4) — з 1199, три й менше — з 991.
 *
 * centeredSlidesBounds прибирає порожнє поле збоку на першому й останньому
 * слайдах: без нього centeredSlides центрує крайню картку, і півекрана лишається
 * пустим (власник 20.09.2026: «поля є справа і зліва від слайдера»).
 */
(function () {
  if (typeof Swiper === 'undefined') return;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.phpdev-pricing').forEach(function (root) {
    var el = root.querySelector('.plans.swiper');
    if (!el) return;

    // ⚠ пороги — у парі з @media у style.scss
    var mq = window.matchMedia(el.classList.contains('cols-4') ? '(max-width: 1199px)' : '(max-width: 991px)');

    var slides = [].slice.call(el.querySelectorAll('.plan'));
    if (slides.length < 2) return;

    var dots = [].slice.call(root.querySelectorAll('.plans-dots button'));
    var rec = Math.max(0, slides.findIndex(function (p) { return p.classList.contains('is-rec'); }));
    var sw = null;

    function mark(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }

    function sync() {
      if (mq.matches && !sw) {
        sw = new Swiper(el, {
          slidesPerView: 'auto',
          centeredSlides: true,
          centeredSlidesBounds: true,
          spaceBetween: 14,
          initialSlide: rec,
          speed: reduce ? 0 : 450,
          grabCursor: true,
          on: { slideChange: function (s) { mark(s.activeIndex); } }
        });
        mark(rec);
      } else if (!mq.matches && sw) {
        sw.destroy(true, true);
        sw = null;
      }
    }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { if (sw) sw.slideTo(k); });
    });

    mq.addEventListener('change', sync);
    sync();
  });
})();
